import React, { useEffect } from "react";
import * as app from "../../services/AppService";
import { useSelector, useDispatch } from "react-redux";
import { getData } from "../../store/data";
import Select, { SelectProps } from "../Select";
import { KeyValue } from "../../models/Core/key-value";

interface Props extends Omit<SelectProps,'options'> {
    withAllBranches?: boolean,
    withOutMainBranch?: boolean,
    onLoad?:(args:any) => any
}
function UserBranches(props: Props) {
    const dispatch: any = useDispatch();

    useEffect(() => {
        dispatch(getData("UserBranches", {}, (UserBranches: KeyValue[]) => {
            if (UserBranches && UserBranches.length > 0 && props.onLoad && typeof props.onLoad == "function") {
                var Branches = UserBranches.filter((r: KeyValue) => +r.Key !== 1 || !props.withOutMainBranch)
                if (Branches.length > 0)
                    props.onLoad(Branches);
            }
        })
        );
    }, []);

    const selector = useSelector((store: any) => store.data.UserBranches);
    const UserBranches = (props.withAllBranches
        ? [{ Value: app.translate("AllBranchs"), Key: 0 }, ...selector]
        : selector).filter((r: KeyValue) => +r.Key !== 1 || !props.withOutMainBranch);

    return (
        <Select id="UserBranches" label={"Branch"} {...props} options={UserBranches} />
    );
}

UserBranches.defaultProps = {
  withAllBranches: false,
};

export default UserBranches;
